var _mask, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChevronDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_12549_4463",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 12,
    height: 8,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    width: 12,
    height: 8
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.79823 5.5573L2.67104 3.66554C2.31384 3.34787 2.31384 2.78966 2.67104 2.47199V2.47199C2.97368 2.20285 3.42986 2.20285 3.7325 2.47199L5.33545 3.89754C5.7144 4.23455 6.2856 4.23455 6.66455 3.89754L8.2675 2.47199C8.57014 2.20285 9.02632 2.20285 9.32896 2.47199V2.47199C9.68616 2.78966 9.68616 3.34787 9.32896 3.66554L7.20177 5.5573C6.53805 6.14756 5.46195 6.14757 4.79823 5.5573Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.79823 5.5573L2.67104 3.66554C2.31384 3.34787 2.31384 2.78966 2.67104 2.47199V2.47199C2.97368 2.20285 3.42986 2.20285 3.7325 2.47199L5.33545 3.89754C5.7144 4.23455 6.2856 4.23455 6.66455 3.89754L8.2675 2.47199C8.57014 2.20285 9.02632 2.20285 9.32896 2.47199V2.47199C9.68616 2.78966 9.68616 3.34787 9.32896 3.66554L7.20177 5.5573C6.53805 6.14756 5.46195 6.14757 4.79823 5.5573Z",
    fill: "#3E5067"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.79823 5.5573L2.67104 3.66554C2.31384 3.34787 2.31384 2.78966 2.67104 2.47199V2.47199C2.97368 2.20285 3.42986 2.20285 3.7325 2.47199L5.33545 3.89754C5.7144 4.23455 6.2856 4.23455 6.66455 3.89754L8.2675 2.47199C8.57014 2.20285 9.02632 2.20285 9.32896 2.47199V2.47199C9.68616 2.78966 9.68616 3.34787 9.32896 3.66554L7.20177 5.5573C6.53805 6.14756 5.46195 6.14757 4.79823 5.5573Z",
    stroke: "white",
    strokeWidth: 4,
    mask: "url(#path-1-outside-1_12549_4463)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron_down.c379a339.svg";
export { ForwardRef as ReactComponent };